// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left[data-v-c3578e5a]{text-align:left}.icon[data-v-c3578e5a]{font-size:20px}.icon-close[data-v-c3578e5a]{font-size:17px}.pd-12[data-v-c3578e5a]{margin:0;padding:12px 0}", ""]);
// Exports
module.exports = exports;
